import TransparentButton from './transparent-button/TransparentButton';
import React from 'react';

export const AddButton = ({ onClick, label }) => (
    <TransparentButton onClick={onClick}>
        <i className={'material-icons'}>add_circle_outline</i>
        {label && <span>{label}</span>}
    </TransparentButton>
);
